var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearchResult = function SvgNoSearchResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 74,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-search-result_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 2,
    d: "m38.926 49 23-23m-.852 23-23-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.333,
    cy: 51.333,
    r: 12.833,
    stroke: "#D7D7D7",
    strokeWidth: 3.385
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeLinecap: "square",
    strokeWidth: 3.385,
    d: "m83.417 61.416 8.25 8.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M21 62h2.417v2H21a2 2 0 0 1-2-2v-2.284h2zm12.083 2H28.25v-2h4.833zm9.667 0h-4.833v-2h4.833zm9.667 0h-4.834v-2h4.834zm9.666 0H57.25v-2h4.833zm5.477-2a12.4 12.4 0 0 0 4.19 1.376V64h-4.833v-2zm12.77 1.49A2 2 0 0 1 79 64h-2.417v-.5H80q.165-.001.33-.01M21 55.15h-2v-4.567h2zm0-9.133h-2V41.45h2zm0-9.133h-2v-4.566h2zm60 0h-2v-4.566h2zM22.813 24.035 21 25.468v2.283h-2v-2.283a2 2 0 0 1 .76-1.57l1.812-1.432 1.24 1.57Zm57.427-.136a2 2 0 0 1 .76 1.569v2.283h-2v-2.283l-1.813-1.433 1.24-1.569zm-51.418-7.163 1.24 1.57-3.625 2.864-1.24-1.568V19.6l3.624-2.866zM74.803 19.6l-1.24 1.57-3.626-2.864 1.24-1.57zm-37.49-7.025-3.626 2.866-1.24-1.57 3.625-2.865 1.24 1.57Zm30.239 1.296-1.24 1.57-3.624-2.866 1.239-1.569zM44.563 6.846 40.937 9.71l-1.24-1.57 3.625-2.864 1.24 1.569Zm15.739 1.296-1.24 1.57-3.624-2.866 1.239-1.57zM48.76.98a2 2 0 0 1 2.48 0l1.812 1.431-1.24 1.57L50 2.548l-1.813 1.433-1.24-1.57z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-search-result_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h100v73H0z"
  })))));
};
export default SvgNoSearchResult;